import { render, staticRenderFns } from "./truntable.vue?vue&type=template&id=7ac02b2c&scoped=true"
import script from "./truntable.vue?vue&type=script&lang=js"
export * from "./truntable.vue?vue&type=script&lang=js"
import style0 from "./truntable.vue?vue&type=style&index=0&id=7ac02b2c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac02b2c",
  null
  
)

export default component.exports